import { c as _c } from "react/compiler-runtime";
import { useAppParams } from "@router/router-helper";
import { companyMemberGroupsMemberIdentitySelector, companyMemberGroupsSelector, companyMemberGroupsStatusSelector } from "@store/company-member-groups/company-member-groups-selector";
import { resetCompanyMemberGroupsState } from "@store/company-member-groups/company-member-groups-slice";
import { fetchCompanyMemberGroups } from "@store/company-member-groups/company-member-groups-thunk";
import { selectedSdbCompanyIdSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { useEffect } from "react";
/**
 * Fetches the groups of a company member.
 *
 * They are fetched again whenever the store of the groups is cleared meanwhile, e.g. by the steps to
 * take a Sphere XG seat away, which share that store and clear it once they are done. Those steps
 * may also have changed the groups the member belongs to.
 */
export function useMemberGroups() {
  const $ = _c(17);
  const dispatch = useAppDispatch();
  const {
    memberId,
    teamId
  } = useAppParams();
  const groups = useAppSelector(companyMemberGroupsSelector);
  const storedStatus = useAppSelector(companyMemberGroupsStatusSelector);
  const storedMemberIdentity = useAppSelector(companyMemberGroupsMemberIdentitySelector);
  const hasSelectedWorkspace = !!useAppSelector(selectedSdbCompanyIdSelector);
  const id = memberId || teamId;
  const areGroupsCleared = storedStatus === "uninitialized";
  const companyMemberGroupsStatus = !!id && storedMemberIdentity === id ? storedStatus : "uninitialized";
  let t0;
  let t1;
  if ($[0] !== areGroupsCleared || $[1] !== dispatch || $[2] !== hasSelectedWorkspace || $[3] !== id) {
    t0 = () => {
      if (id && areGroupsCleared && hasSelectedWorkspace) {
        dispatch(fetchCompanyMemberGroups({
          memberId: id
        }));
      }
    };
    t1 = [dispatch, id, areGroupsCleared, hasSelectedWorkspace];
    $[0] = areGroupsCleared;
    $[1] = dispatch;
    $[2] = hasSelectedWorkspace;
    $[3] = id;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  let t2;
  if ($[6] !== dispatch) {
    t2 = () => () => {
      dispatch(resetCompanyMemberGroupsState());
    };
    $[6] = dispatch;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== dispatch || $[9] !== id) {
    t3 = [dispatch, id];
    $[8] = dispatch;
    $[9] = id;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useEffect(t2, t3);
  let t4;
  if ($[11] !== companyMemberGroupsStatus || $[12] !== groups) {
    t4 = companyMemberGroupsStatus === "uninitialized" ? [] : groups;
    $[11] = companyMemberGroupsStatus;
    $[12] = groups;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== companyMemberGroupsStatus || $[15] !== t4) {
    t5 = {
      groups: t4,
      companyMemberGroupsStatus
    };
    $[14] = companyMemberGroupsStatus;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}